import {
	immunodepressioni,
	listaParamIsolamento, listaParamIsolamentoCI,
	patologie,
	rischiEsposizione,
	sintomi
} from "../../utils/arrays/Generics";

export function getIntervistaApiData(intervista) {
	return {
		...intervista,
		paesiEsteri: intervista.paesiEsteri ? intervista.paesiEsteri.join(",") : "",
		regioniVisitate: intervista.regioniVisitate ? intervista.regioniVisitate.join(",") : "",
		listaSintomi: getListaOf(sintomi, intervista),
		listaPatologieCroniche: getListaOf(patologie, intervista),
		listaImmunodepressioni: getListaOf(immunodepressioni, intervista),
		listaEspRischio: getListaOf(rischiEsposizione, intervista),
		parametriIsolamento: getListaOf([...listaParamIsolamento, ...listaParamIsolamentoCI], intervista),
		//note: note
	}
}

export function getListaOf(arrayToSearch, intervista) {
	let array = []
	arrayToSearch.forEach(item => {
		if (intervista[item.replace(/[\W_]+/g, "_")]) {
			array.push(item)
		}
	})
	return array.join(",");
}

export function getTagListaOf(arrayToSearch, intervista) {
	let array = []
	arrayToSearch.forEach(item => {
		if (intervista[item.replace(/[\W_]+/g, "_")]) {
			array.push("#" + item.replaceAll(" ", "_"))
		}
	})
	return array.join(" ");
}

export function getArrayOf(arrayToSearch, intervista) {
	if (!intervista) {
		console.error("Hey, manca l'intervista! Coglione");
		return [];
	}
	let array = [];
	arrayToSearch.forEach(item => {
		if (intervista[item.replace(/[\W_]+/g, "_")]) {
			array.push(item)
		}
	})
	return array;
}

export function checkParametri(watch) {
	return watch(listaParamIsolamento[0].replace(/[\W_]+/g, "_")) ||
		watch(listaParamIsolamento[1].replace(/[\W_]+/g, "_")) ||
		watch(listaParamIsolamento[2].replace(/[\W_]+/g, "_")) ||
		watch(listaParamIsolamento[3].replace(/[\W_]+/g, "_")) ||
		watch(listaParamIsolamentoCI[0].replace(/[\W_]+/g, "_")) ||
		watch(listaParamIsolamentoCI[1].replace(/[\W_]+/g, "_")) ||
		watch(listaParamIsolamentoCI[2].replace(/[\W_]+/g, "_")) ||
		watch(listaParamIsolamentoCI[3].replace(/[\W_]+/g, "_"));
}
